(function() {
    'use strict';
    angular
        .module('ccsTrApp')
        .factory('Port', Port);

    Port.$inject = ['$resource', 'DateUtils'];

    function Port ($resource, DateUtils) {
        var resourceUrl =  'api/ports/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createdOn = DateUtils.convertDateTimeFromServer(data.createdOn);
                        data.modifiedOn = DateUtils.convertDateTimeFromServer(data.modifiedOn);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
